import { clsx, type ClassValue } from "clsx";
import { twMerge } from "tailwind-merge";

export enum SortOptions {
    VACANCY_ASCENDING = "vacancy:asc",
    VACANCY_DESCENDING = "vacancy:desc",
    PRICE_ASCENDING = "price:asc",
    PRICE_DESCENDING = "price:desc",
    AREA_ASCENDING = "area:asc",
    AREA_DESCENDING = "area:desc",
}

export enum CountryCodes {
    US = "US",
    CA = "CA",
    UK = "UK",
    AU = "AU",
}

export enum FunnelType {
    RESERVE = "reserve",
    RENT = "rent",
    QUOTE = "quote",
}

export enum QuoteType {
    RESERVE = "reserve",
    CALL = "call",
}

export enum ButtonLayout {
    COMBINED = "combined",
    SEPARATE = "separate",
}

export enum TableLayout {
    GRID = "grid",
    ROW = "row",
}

export enum AppLocation {
    DIALOG = "dialog",
    ACCORDION = "accordion",
    EXTERNAL = "external",
    DRAWER = "drawer",
}

export enum ReservationType {
    RESERVE_ONLY = "reserve_only",
    CLICK_TO_CALL = "click_to_call",
}

export function get<T, R = undefined>(
    obj: T,
    path: string,
    defaultValue?: R,
): R | unknown {
    if (obj == null) return defaultValue;
    const keys = path.split(".");
    let result: unknown = obj;
    for (const key of keys) {
        if (result !== null && typeof result === "object" && key in result) {
            result = (result as Record<string, unknown>)[key];
        } else {
            return defaultValue;
        }
    }
    return result === undefined ? defaultValue : result;
}

export function cn(...inputs: ClassValue[]) {
    return twMerge(clsx(inputs));
}
